const BROWSER_RENDERABLE_IMAGE_TYPES: ReadonlySet<string> = new Set([
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/avif',
    'image/svg+xml',
    'image/bmp',
]);

const normalizeMimeType = (mimeType: unknown): string => (typeof mimeType === 'string' ? mimeType.trim().toLowerCase() : '');

const isImageMimeType = (mimeType: unknown): boolean => normalizeMimeType(mimeType).startsWith('image/');

/** Formats the browser can show in an `img`; TIFF and documents get a placeholder. */
const isBrowserRenderableImage = (mimeType: unknown): boolean => BROWSER_RENDERABLE_IMAGE_TYPES.has(normalizeMimeType(mimeType));

/**
 * Short file format for the card badge: the file extension in upper case, or the
 * MIME subtype when the file name has none (`image/tiff` → `TIFF`).
 */
const fileFormatOf = (filename: unknown, mimeType: unknown): string => {
    if (typeof filename === 'string') {
        const name = filename.trim();
        const dot = name.lastIndexOf('.');
        if (dot > 0 && dot < name.length - 1) {
            return name.slice(dot + 1).toUpperCase();
        }
    }

    const subtype = normalizeMimeType(mimeType).split('/')[1] ?? '';
    return subtype.replace(/^x-/, '').split('+')[0].split(';')[0].toUpperCase();
};

export { fileFormatOf, isBrowserRenderableImage, isImageMimeType };
